import { getGlobalInitData } from '@/api/public';
import logger from '@/utils/client-logger';
import { EPlatform } from '@/utils/enums/platform-enum';
import { getCookie } from '@/utils/tools';

/** 与会员等级相关的文案/规则（第二件半价、包邮等） */
const MEMBER_PUBLIC_RESOURCE_CONFIG_NAMES = [
  'product_content_free_shipping_member',
  'product_content_half_price_member',
] as const;

function resolveIsWebForGlobalInit(): boolean {
  const deviceType = getCookie('deviceType') || String(EPlatform.WAP);
  return deviceType === String(EPlatform.WEB);
}

/**
 * 拉取全局 init 中与会员相关的 config_names 增量。
 * 典型调用：入会（JoinFreeDialog）、退会（exitMember）、支付成功页等级可能变化时。
 */
export async function fetchMemberRelatedPublicResourceConfigNames(): Promise<Record<
  string,
  unknown
> | null> {
  try {
    const res = await getGlobalInitData(resolveIsWebForGlobalInit(), {
      config_names: [...MEMBER_PUBLIC_RESOURCE_CONFIG_NAMES],
    });
    const raw = res?.data?.config_names;
    if (!raw || typeof raw !== 'object') {
      return null;
    }
    const record = raw as Record<string, unknown>;
    const memberConfigNames = MEMBER_PUBLIC_RESOURCE_CONFIG_NAMES.reduce<Record<string, unknown>>(
      (acc, key) => {
        if (record[key] !== undefined) {
          acc[key] = record[key];
        }
        return acc;
      },
      {},
    );
    if (Object.keys(memberConfigNames).length === 0) {
      return null;
    }
    return memberConfigNames;
  } catch (error) {
    logger.error('Failed to fetch member-related public resource (shipping / half-price)', error);
    return null;
  }
}
